import httpClient from '../core/httpClient';

const RESOURCE_PATH = '/api/v2/user-settings';

export async function listUserSettings() {
  const response = await httpClient.get(RESOURCE_PATH);
  const body = response.data;
  console.info('[userSettingsApi] listUserSettings: pobrano ustawienia', {
    count: body?.data?.length,
  });
  return body;
}

export async function getUserSetting(key) {
  const response = await httpClient.get(`${RESOURCE_PATH}/${encodeURIComponent(key)}`);
  const body = response.data;
  console.info('[userSettingsApi] getUserSetting:', { key });
  return body;
}

export async function upsertUserSetting(key, value) {
  const response = await httpClient.put(`${RESOURCE_PATH}/${encodeURIComponent(key)}`, {
    value,
  });
  const body = response.data;
  console.info('[userSettingsApi] upsertUserSetting:', { key });
  return body;
}

export async function deleteUserSetting(key) {
  const response = await httpClient.delete(`${RESOURCE_PATH}/${encodeURIComponent(key)}`);
  const body = response.data;
  console.info('[userSettingsApi] deleteUserSetting:', { key, message: body?.message });
  return body;
}
